export default {
  endpoint: {
    url: {
      allowLocal: false,
      message: "Insira uma URL válida."
    }
  }
};



// WEBPACK FOOTER //
// ./src/core/constraint/webhook.constraint.js